import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'src/axios';
import { IDesign } from "src/interfaces/design";
import biLoggingService, {ErrorReportData, SeverityType} from 'src/services/bi-logging/bi-logging.service';

const errorMessage = 'Get design failed.';
export const getDesignAsync  = createAsyncThunk('design/fetchDesign',
    async (args: { orderId: string;
        messageId: string, bizContext: string }, thunkAPI) => {
        try {
            const response = await axios.get<IDesign>(`3d-preview/${args.orderId}/${args.messageId}`,{
                headers: {
                    'X-ITERO-BIZCTX': args.bizContext,
                },
            });

            const sessionTagsData = {
                designState: response.data.status
            };
            biLoggingService.sendSessionTags(sessionTagsData);

            return response.data;
        } catch (e) {
            const errorData: ErrorReportData = {
                object: errorMessage,
                code: '',
                description: errorMessage,
                severity: SeverityType.Error
            }
            biLoggingService.sendErrorReport(errorData);
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);
